import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
export type {
  TabGroupProps as HeadlessTabGroupProps,
  TabListProps as HeadlessTabListProps,
  TabPanelProps as HeadlessTabPanelProps,
  TabPanelsProps as HeadlessTabPanelsProps,
  TabProps as HeadlessTabProps
} from '@headlessui/react'

export const HeadlessTab = Object.assign(Tab, {
  Group: TabGroup,
  List: TabList,
  Panel: TabPanel,
  Panels: TabPanels
})
